import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Button, DialogActions } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from "react-i18next";
import { toJS } from "mobx";

/**
 * סוגי הודעות עבור מודל הודעה
 */
export type MessageModalType = 'success' | 'error' | 'info';

/**
 * סטייט עבור MessageModal
 */
export interface MessageModalState {
  isOpen: boolean;
  type: MessageModalType;
  title?: string;
  message?: string;
}

export interface MessageModalProps {
    isOpen: boolean;
    onClose?: () => void;
    title?: string;
    message?: string | React.ReactNode;
    type?: MessageModalType;
    confirmButtonText?: string;
}

const MessageModal: React.FC<MessageModalProps> = ({ isOpen, onClose, title, message, type, confirmButtonText = "אישור" }) => {
    const { t } = useTranslation();
    
    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircleIcon sx={{ color: "white", fontSize: 64, background: "#b689e3", borderRadius: "50%" }} />;
            case 'error':
                return <ErrorIcon sx={{ color: "white", fontSize: 64, background: "#b689e3", borderRadius: "50%" }} />;
            case 'info':
                return <InfoIcon sx={{ color: 'white', fontSize: 64, background: "#b689e3", borderRadius: "50%" }} />;
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            className="message-modal"
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    zIndex: 3,
                    color: 'white'
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogTitle component="h3">
                {getIcon()}
                {title && title}
            </DialogTitle>
            <DialogContent sx={{
                textAlign: 'center',
                padding: '32px',
                position: 'relative'
            }}>
                <div style={{
                    fontSize: '16px',
                    lineHeight: '24px'
                }}>
                    {message}
                </div>
            </DialogContent>
            <DialogActions style={{ marginBottom: 0 }}>
                <Button
                    className=""
                    onClick={onClose}
                    variant="contained"
                >
                    {t('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MessageModal; 